import { render, staticRenderFns } from "./SubcontractorTeamsCard.vue?vue&type=template&id=61e3e42e"
import script from "./SubcontractorTeamsCard.vue?vue&type=script&lang=ts"
export * from "./SubcontractorTeamsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports